<template>
  <section v-if="count != null && count !== ''" class="comment-priority" aria-label="商品评论待审核提醒">
    <a-icon type="message" class="comment-icon" />
    <div class="comment-message">
      <h2><strong>{{ Number(count).toLocaleString('zh-CN') }}</strong> 条商品评论待审核</h2>
      <p>待审核的商品评价（含系统默认好评），请及时处理。点击后进入商品评论并筛选待审核。</p>
    </div>
    <a-button type="primary" size="large" @click="$emit('process')">去操作<a-icon type="arrow-right" /></a-button>
  </section>
</template>

<script>
export default {
  name: 'PendingComments',
  props: { count: { type: [Number, String], default: null } }
}
</script>

<style scoped>
.comment-priority{display:flex;align-items:center;gap:18px;padding:22px 26px;margin-bottom:18px;border:1px solid #c9dde8;border-left:5px solid #3a7ca5;border-radius:12px;background:#f3f9fc;box-shadow:0 3px 12px rgba(58,124,165,.06)}
.comment-icon{font-size:32px;color:#3a7ca5}.comment-message{flex:1;min-width:0}.comment-message h2{margin:0;color:#1f4d66;font-size:19px;font-weight:600}.comment-message strong{font-size:30px;margin-right:5px;font-variant-numeric:tabular-nums}.comment-message p{margin:6px 0 0;color:#5a7a8c;font-size:13px;line-height:1.7}.comment-priority /deep/ .ant-btn-primary{background:#237b67;border-color:#237b67;flex-shrink:0}
@media(max-width:650px){.comment-priority{display:grid;grid-template-columns:26px minmax(0,1fr);padding:18px;gap:12px}.comment-icon{font-size:26px}.comment-message h2{font-size:16px}.comment-priority /deep/ .ant-btn{grid-column:2;justify-self:start}}
</style>